export default {
  "b2b.konfiguracni-parametry-editace-widget.label.last-modification":
    "Last modification",
  "b2b.konfiguracni-parametry-editace-widget.title":
    "Portal Configuration Parameters",
  "b2b.konfiguracni-parametry-editace-widget.submit": "Save",
  "b2b.konfiguracni-parametry-editace-widget.save-daialog.title":
    "Saving Portal Parameters"
};
